<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.userName"
              placeholder="请输入名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.phone"
              placeholder="请输入电话"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.storeName"
              placeholder="请输入店名"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @view="viewFun(arguments)"
        @start="startFun(arguments)"
        @stop="stopFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>
    <!-- 新增 修改 查看-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditViewTitle"
      :dialog-visible.sync="dialogAddEditViewVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 新增 修改
import AddEditViewDialog from './components/addEditViewDialog'
// 数据请求
import { loadAppUserBlacklistListDataApi, loadAppUserBlacklistExportDataApi, saveOrUpdateAppUserBlacklistApi } from '@/api/appUserBlacklist'

export default {
  name: 'AppUserBlacklist',
  components: {
    CustomTable,
    TableOperation,
    AddEditViewDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'app_user_blacklist_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['app_user_blacklist_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['app_user_blacklist_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['app_user_blacklist_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['app_user_blacklist_start'],
            prop: 'start',
            label: '启用',
            method: 'start'
          },
          {
            permissionSigns: ['app_user_blacklist_stop'],
            prop: 'stop',
            label: '停用',
            method: 'stop'
          },
          {
            permissionSigns: ['app_user_blacklist_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            userName: '',
            storeName: '',
            phone: ''
          }
        }
      },
      id: null, // 选中的单据ID
      eventType: '',
      dialogAddEditViewTitle: '',
      dialogAddEditViewVisible: false
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', filterColumn: 'r.province_name', label: '省区', width: 120 },
      { prop: 'cityName', filterColumn: 'r.city_name', label: '城市', width: 120 },
      { prop: 'appUserName', filterColumn: 'r.name', label: '名称', width: 120 },
      { prop: 'phone', filterColumn: 'r.phone', label: '电话', width: 140 },
      { prop: 'storeName', filterColumn: 'r.store_name', label: '店名', width: 160 },
      { prop: 'certificateNo', filterColumn: 'r.certificate_no', label: '专卖证号', width: 160 },
      { prop: 'benxiangStoreNo', filterColumn: 'r.benxiang_store_no', label: '本香门店码', width: 160 },
      { prop: 'typeStr', filterColumn: 'bill.type', filterValue: 'type', label: '类型', width: 100, filterArray: [{ label: '全部', value: 1 }, { label: '宣介会', value: 2 }, { label: '微信活动', value: 3 }] },
      { prop: 'startDateStr', filterColumn: 'bill.start_date', label: '开始时间', width: 120, isBetween: true },
      { prop: 'endDateStr', filterColumn: 'bill.end_date', label: '结束时间', width: 120, isBetween: true },
      { prop: 'statusStr', filterColumn: 'bill.status', filterValue: 'status', label: '状态', width: 100, filterArray: [{ label: '启用', value: 1 }, { label: '停用', value: 2 }] },
      { prop: 'remark', filterColumn: 'bill.remark', label: '备注' },
      { prop: 'operatorName', filterColumn: 'bill.operator_name', label: '操作人', width: 150 },
      { prop: 'operationTimeStr', filterColumn: 'bill.operation_time', label: '操作时间', width: 160, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadAppUserBlacklistListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 新增
    addFun () {
      this.eventType = 'add'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '新增微信零售户黑名单'
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '修改微信零售户黑名单'
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '查看微信零售户黑名单'
    },
    // 启用
    startFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status !== 2) {
        this.$message({
          message: '数据不在停用状态，不能启用',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确定启用该微信零售户黑名单？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateAppUserBlacklistApi({ id: args[0].id, isStart: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 停用
    stopFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status !== 1) {
        this.$message({
          message: '数据不在启用状态，不能停用',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确定停用该微信零售户黑名单？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateAppUserBlacklistApi({ id: args[0].id, isStop: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadAppUserBlacklistExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
